<template>
  <v-app>
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-toolbar dark>
            <v-card-title class="headline">
              {{ !edit ? 'Add' : 'Update' }} resource category
              <hr>
            </v-card-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-spacer></v-spacer>
              <v-btn icon  @click="closeDialog">
                <i class="fas fa-times"></i>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field outlined dense v-model="category.title" label="Title"></v-text-field>
                  <span class="text-danger" v-if="$v.category.title.$error">This information is required</span>
                </v-col>
                <v-col cols="6">
                  <v-file-input outlined dense v-model="category.image" label="Image"  prepend-icon=""
                                prepend-inner-icon="mdi-file"></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-textarea outlined dense v-model="category.description" label="Description"></v-textarea>
                </v-col>
                <v-col cols="12">
                  <span class="font-weight-medium">Status</span>
                  <v-switch v-model="category.is_active"  :label="category.is_active?'Active':'Inactive'" ></v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="float-right">

              <v-btn
                  class="btn btn-standard cancel-btn" depressed
                  @click="closeDialog"
              >Cancel
              </v-btn>

              <v-btn
                  class="text-white ml-2 btn btn-primary"
                  depressed
                  @click="createOrUpdate"
                  :loading="loading"
              >Save
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import CategoryService from "@/core/services/library/resource/CategoryService";

const resourceCategoryService = new CategoryService();

export default {
  name: "CreateAndUpdate",
  validations() {
    return {
      category: this.rules
    }
  },
  data() {
    return {
      category: {
        title: null,
        image: null,
        is_active: 1,
        description: null
      },
      loading: false,
      edit: false,
      dialog: false,
    }
  }, computed: {
    rules() {
      return {
        title: {required}
      };
    }
  },
  methods: {
    generateFd() {
      let fd = new FormData();
      for (let key in this.category) {
        if (
            key == "image" &&
            this.category["image"] &&
            this.category["image"] != null
        ) {
          fd.append("image", this.category["image"]);
        } else if (key == "is_active") {
          fd.append("is_active", this.category["is_active"] ? 1 : 0);
        } else {
          fd.append(key, this.category[key]);
        }
      }
      return fd;
    },
    createOrUpdate() {
      this.$v.$touch()
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        let fd = this.generateFd();
        if (this.edit) {
          this.update(fd);
        } else {
          this.save(fd);
        }
      }
    },

    update(fd) {
      this.loading = true;
      resourceCategoryService.update(this.category.id, fd).then(response => {
        this.$snotify.success("Updated successfully")
        this.reset();
        this.$emit("refresh");
        this.loading = false;
      }).catch(error => {
        let errors = error.errors
        for (let key in errors) {
          this.$snotify.error(errors[key][0])
        }
        this.$snotify.error(error.message)
      }).finally(() => {
        this.isBusy = false;
        this.loading = false;
      })
    },
    save(fd) {
      this.loading = true;
      resourceCategoryService.store(fd).then(response => {
        this.$snotify.success("Created successfully")
        this.reset();
        this.$emit("refresh");
      })
          .catch(error => {
        let errors = error.errors
        for (let key in errors) {
          this.$snotify.error(errors[key][0])
        }
        this.$snotify.error(error.message)
      }).finally(() => {
        this.isBusy = false;
        this.loading = false;
      })
    },
    closeDialog() {
      this.edit = false;
      this.dialog = false;
      this.$emit("refresh");
    },
    reset() {
      this.$v.$reset();
      this.category = {
        title: null,
        is_active: 1,
        description: null
      };
      this.dialog=false;
      this.edit=false;
    },
    createCategory() {
      this.dialog = true;
      this.edit = false;
    },
    editCategory(category) {
      this.category.image=null;
      this.category = category;
      this.edit = true;
      this.dialog=true;
    }
  }
}
</script>

<style scoped>

</style>